import { formatTimeString, getRepeatEndDate } from '~libs/dayjs';

import { faEdit } from '~components/icon';
import { Column, Row } from '~components/table-view';
import { linkCellRender } from '~components/table-view/columnRenderers';
import { getEncryptedColumnProps } from '~libs/encryptionSettings';

export const getColumns = (onOpen: (row: Row) => void): Column[] => [
  {
    id: 'client.full_name',
    header: 'Client',
    type: 'text',
    deriveValue: (row) => row.client?.full_name ?? '',
    renderReadOnly: linkCellRender(onOpen, faEdit),
    ...getEncryptedColumnProps(),
  },
  {
    id: 'user.full_name',
    header: 'Care Worker',
    type: 'text',
    deriveValue: (row) => row.user?.full_name ?? '',
  },
  {
    id: 'client.referrer_name',
    header: 'Referrer',
    type: 'text',
    deriveValue: (row) => row.client?.referrer_name ?? '',
  },
  {
    id: 'client.region.name',
    header: 'Client Region',
    type: 'text',
    deriveValue: (row) => row.client?.region?.name ?? '',
  },
  {
    id: 'repeat_start',
    header: 'Repeat Start',
    type: 'date',
  },
  {
    id: 'repeat_end',
    header: 'Repeat End',
    type: 'text',
    deriveValue: ({ repeat_end }) => getRepeatEndDate(repeat_end),
  },
  {
    id: 'start_time',
    header: 'Start Time',
    type: 'text',
    deriveValue: ({ start_time }) => formatTimeString(start_time),
  },
  {
    id: 'end_time',
    header: 'End Time',
    type: 'text',
    deriveValue: ({ end_time }) => formatTimeString(end_time),
  },
  {
    id: 'repeat_frequency.day',
    header: 'Week Day',
    type: 'text',
    deriveValue: (row) => row.repeat_frequency?.day ?? '',
  },
  {
    id: 'repeat_frequency.frequency',
    header: 'Week Repeat Count',
    type: 'text',
    deriveValue: (row) => row.repeat_frequency?.frequency ?? '',
  },
  {
    id: 'status.name',
    header: 'Status',
    type: 'text',
    deriveValue: (row) => row.status?.name ?? '',
  },
  {
    id: 'service_type.name',
    header: 'Service Type',
    type: 'text',
    deriveValue: ({ service_type }) =>
      service_type !== undefined ? `${service_type.name}${service_type.deleted ? ' - DELETED' : ''}` : '',
  },
  {
    id: 'package_fixed.name',
    header: 'Package',
    type: 'text',
    deriveValue: (row) => row.package_fixed?.name ?? '',
  },
];

export default getColumns;
